// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"essential":"8f67bab29857d1cde9f3","app":"36b8ceaff89b3f3d235f"}[chunkId] + ".css";
};